import React, { createContext, useContext, useState } from "react";
import "./ConfirmModal.css"; // optional, create this for styling

const ConfirmContext = createContext();
export const useConfirm = () => useContext(ConfirmContext);

export const ConfirmProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [onConfirm, setOnConfirm] = useState(null);

  const confirm = (message) => {
    setMessage(message);
    setIsOpen(true);
    return new Promise((resolve) => {
      setOnConfirm(() => (choice) => {
        setIsOpen(false);
        resolve(choice);
      });
    });
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {isOpen && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <p>{message}</p>
            <div className="confirm-buttons">
              <button className="confirm-yes" onClick={() => onConfirm(true)}>Yes</button>
              <button className="confirm-no" onClick={() => onConfirm(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};
